import {HttpStatusCode} from "axios";
import {toastUtils} from "../../../../common/utils/Toastutils";
import {makeAutoObservable} from "mobx";
import {smartPosService} from "./SmartPosService";
interface StaticParam {
    page_number: number | 0;
    per_page: number;
    search: string ;
    status: string | null;
    vendor_name: string ;
}
interface IdataSmartPos {
    pos_name: string;
    vendor_name: string;
    status: string | null;
    data: {
        pos_id: string;
        secret_key: string;
        merchant_id: string;
    };
}
class SmartPosStore{
    openModal: boolean = false; //trạng thái popup thêm/sửa
    typeModal: string = "add"; // Lại popup  sửa hoặc thêm
    dataListSmartPos: any[] = [] // Danh sách Smart Pos
    idSmartPos: number | undefined; // Danh sách Smart Pos
    searchTemp: string = ""; // Seach

    isLoading: boolean = true;
    isSave: boolean = false
    allowSearch: boolean = false;

    formDataSmartPos: IdataSmartPos = {
        pos_name: "",
        vendor_name: "",
        status: null,
        data: {
            pos_id: '',
            secret_key: '',
            merchant_id: '',
        }
    };

    metadata: any = {
        total: null,
        page: 1,
        total_page: null,
        size: null,
    };

    constructor() {
        makeAutoObservable(this)
    }
    staticParam: StaticParam = {
        page_number: 0,
        per_page: 20,
        search: "",
        status: null,
        vendor_name: "",
    };
    async fetchListSmartPos(run?:boolean) {
        const params = {
            page_number: this.staticParam.page_number + 1,
            per_page: this.staticParam.per_page,
            search: this.staticParam.search,
            status: this.staticParam.status,
            vendor_name: this.staticParam.vendor_name,
        }
        if(this.dataListSmartPos.length < 1 || run){
            this.isLoading = true;
        }
        const result = await smartPosService.fetchListSmartPos(params);
        if (result.status === HttpStatusCode.Ok) {
            this.dataListSmartPos = result.body.data;
            this.metadata = result.body.metadata
            this.isLoading = false
        } else {
            toastUtils.error("Đã có lỗi xảy ra", "");
            this.isLoading = false
        }
    }

    async createSmartPos({ form }: { form: any }) {
        if(this.isSave === false){
            this.isSave = true
            const {
                pos_name,
                vendor_name,
                status,
                data:{
                    pos_id,
                    secret_key,
                    merchant_id,
                }
            } = this.formDataSmartPos;
            const params = {
                pos_name: pos_name,
                vendor_name: vendor_name,
                status: status ? parseInt(status) : 1,
                data: {
                    pos_id: pos_id,
                    secret_key: secret_key,
                    merchant_id: merchant_id
                },
            };
            this.openModal = true;
            const result = await smartPosService.fetchCreateSmartPos(params);
            this.isSave = false
            if (result.status === HttpStatusCode.Ok) {
                toastUtils.success("Thêm mới thành công", "");
                form.resetFields();
                smartPosStore.formDataSmartPos.status = null;
                smartPosStore.formDataSmartPos.vendor_name = '';
                this.openModal = false;
                this.dataListSmartPos.unshift(result.body.current); // Thêm data mới vào đầu mảng
                if (this.staticParam.per_page < this.dataListSmartPos.length){
                    this.dataListSmartPos.pop(); // Xóa phần tử cuối cùng ra khỏi mảng
                }
            } else {
                if (typeof result.body.message === "string") {
                    toastUtils.error(result.body.message ?? "Đã có lỗi xảy ra");
                } else if (typeof result.body.message === "object") {
                    const fields = Object.entries(result.body.message).map(([key, value]) => ({
                        name: key,
                        errors: [value as string],
                    }));

                    if (fields.length) {
                        form.setFields(fields);
                    }
                }
            }
        }

    }
    async updateSmartPos({ form }: { form: any }) {
        if (!this.idSmartPos){
            toastUtils.warning("Chưa có ID Smart Pos");
            return false;
        }
        if(this.isSave === false){
            this.isSave = true
            const {
                pos_name,
                vendor_name,
                status,
                data:{
                    pos_id,
                    secret_key,
                    merchant_id,
                }
            } = this.formDataSmartPos;
            const params = {
                pos_name: pos_name,
                vendor_name: vendor_name,
                status: status ? parseInt(status) : 1,
                data: {
                    pos_id: pos_id,
                    secret_key: secret_key,
                    merchant_id: merchant_id
                },
            };
            this.openModal = true;
            const result = await smartPosService.fetchUpdateSmartPos(params,this.idSmartPos);
            this.isSave = false
            if (result.status === HttpStatusCode.Ok) {
                toastUtils.success("Cập nhật thành công", "");
                this.dataListSmartPos = this.dataListSmartPos.map((item:any) => {
                    if(item.id === this.idSmartPos){
                        item.pos_name = pos_name
                        item.vendor_name = vendor_name
                        item.status = status ? parseInt(status) : 1
                        item.data = JSON.stringify({
                            pos_id: pos_id,
                            secret_key: secret_key,
                            merchant_id: merchant_id
                        })
                    }
                    return item;
                })
                form.resetFields();
                smartPosStore.formDataSmartPos.status = null;
                smartPosStore.formDataSmartPos.vendor_name = '';
                this.openModal = false;
                this.idSmartPos = undefined
            } else {
                if (typeof result.body.message === "string") {
                    toastUtils.error(result.body.message ?? "Đã có lỗi xảy ra");
                } else if (typeof result.body.message === "object") {
                    const fields = Object.entries(result.body.message).map(([key, value]) => ({
                        name: key,
                        errors: [value as string],
                    }));

                    if (fields.length) {
                        form.setFields(fields);
                    }
                }
            }
        }

    }
    async updateStatusSmartPos() {
        if (!this.idSmartPos){
            toastUtils.warning("Chưa có ID Smart Pos");
            return false;
        }
        if(this.isSave === false){
            this.isSave = true
            const {
                pos_name,
                vendor_name,
                status,
                data:{
                    pos_id,
                    secret_key,
                    merchant_id,
                }
            } = this.formDataSmartPos;
            const params = {
                pos_name: pos_name,
                vendor_name: vendor_name,
                status: status ? parseInt(status) : 1,
                data: {
                    pos_id: pos_id,
                    secret_key: secret_key,
                    merchant_id: merchant_id
                },
            };
            const result = await smartPosService.fetchUpdateSmartPos(params,this.idSmartPos);
            this.isSave = false
            if (result.status === HttpStatusCode.Ok) {
                toastUtils.success("Cập nhật thành công", "");
                smartPosStore.formDataSmartPos.status = null;
                this.dataListSmartPos = this.dataListSmartPos.map((item:any) => {
                    if(item.id === this.idSmartPos){
                        item.status = status ? parseInt(status) : 1
                    }
                    return item;
                })
                this.openModal = false;
                this.idSmartPos = undefined
            } else {
                if(result.body.message.name === 'smartpos_already_exists'){
                    toastUtils.warning("Smart POS đã tồn tại");
                }else{
                    toastUtils.error("Đã có lỗi xảy ra", "");
                }
            }
        }

    }

    async fetchDeleteRole(id:number) {
        const result = await smartPosService.fetchDeleteSmartPos(id);
        if (result.status === HttpStatusCode.Ok) {
            toastUtils.success("Xóa thành công", "");
            this.dataListSmartPos = this.dataListSmartPos.filter((item:any) => item.id !== id)
        } else {
            toastUtils.error("Đã có lỗi xảy ra", "");
        }
    }
}
export const smartPosStore = new SmartPosStore();